import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationHostTypeService } from '../../../../lib/services/application-host-type.service';
import { ReferenceDataService } from '../../../../lib/services/reference-data.service';
import { BaseSectionNavigationComponent } from '../../../shared/components/base-section-navigation.component';
import { MortgageApplicationContext } from '../../models/mortgage-application-context.model';
import { MortgageApplicationFormService } from '../../services/mortgage-application-form.service';
import { TabNavigationService } from '../../services/tab-navigation.service';
import { MortgageApplicationTabNames } from '../../../../lib/constants/mortgage-applications-tabs-names';
import { MortgageApplicationStore } from './../../services/mortgage-application-store';

@Component({
  selector: 'boi-mortgage-app-section-navigation',
  template: ` <div #container><ng-content></ng-content></div> `
})
export class MortgageAppSectionNavigationComponent extends BaseSectionNavigationComponent implements OnDestroy {
  public mortgageApplication: any;

  constructor(
    protected tabNavigationService: TabNavigationService,
    public mortgageApplicationStore: MortgageApplicationStore,
    public router: Router,
    protected referenceDataService: ReferenceDataService,
    protected readonly applicationHostTypeService: ApplicationHostTypeService,
    protected readonly mortgageApplicationFormService: MortgageApplicationFormService
  ) {
    super(tabNavigationService, router, referenceDataService, applicationHostTypeService);
    this.dataSubscription = this.mortgageApplicationStore.dataObservable.subscribe((data) => {
      this.mortgageApplication = data.mortgageApplicationEntity;
    });
  }

  protected getNextTabRoute(): Array<string> {
    let routeItem = decodeURIComponent(this.router.url).split('/');
    let pageIndex = 3;
    let applicantIndex = 4;

    const interfaceTypeCode = this.applicationHostTypeService.getCode()
      ? this.applicationHostTypeService.getCode().toLowerCase()
      : undefined;
    if (routeItem[1].toLowerCase() === interfaceTypeCode) {
      pageIndex++;
      applicantIndex++;
    }
    switch (routeItem[pageIndex]) {
      case MortgageApplicationTabNames.YOUR_MORTGAGE:
        routeItem[pageIndex] = MortgageApplicationTabNames.APPLICANT;
        routeItem[applicantIndex] = '0';
        break;
      case MortgageApplicationTabNames.APPLICANT:
        if (this.mortgageApplication.Applicants.length - 1 > +routeItem[applicantIndex]) {
          routeItem[applicantIndex] = `${+routeItem[applicantIndex] + 1}`;
        } else {
          routeItem[pageIndex] = this.mortgageApplication.IsAip
            ? MortgageApplicationTabNames.YOUR_PROPERTY
            : MortgageApplicationTabNames.YOUR_OUTGOINGS;
          routeItem.splice(-1, 1);
        }
        break;
      case MortgageApplicationTabNames.YOUR_OUTGOINGS:
        routeItem[pageIndex] = MortgageApplicationTabNames.YOUR_PROPERTY;
        break;
      case MortgageApplicationTabNames.YOUR_PROPERTY:
        if (
          this.mortgageApplication.isFactFind2Visible() &&
          this.mortgageApplicationFormService.getCurrentContext() === MortgageApplicationContext.Internal
        ) {
          routeItem[pageIndex] = MortgageApplicationTabNames.FF2;
        }
        break;
      default:
        routeItem = [];
    }

    return routeItem;
  }
}
